<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Create New Contractor</h4>
          <form class="forms-sample" #ngNewVendorForm="ngForm" name="form"
            (ngSubmit)="ngNewVendorForm.form.valid && onSubmit()" novalidate>

            <div class="row">
              <!-- Name -->
              <div class="col">
                <div class="form-group">
                  <label for="name">Contractor Name</label>
                  <input type="text" class="form-control" id="name" placeholder="ex: ABCD Limited" name="name"
                    [(ngModel)]="name" required>
                </div>
              </div>

              <!-- Email -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Email</label>
                  <input type="email" class="form-control" id="email" placeholder="ex: abcd@mail.com" name="email"
                    [(ngModel)]="email" required>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Phone Number  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Phone Number</label>
                  <input type="tel" class="form-control" id="phone" placeholder="080XXXXXXXX" name="phone"
                    [(ngModel)]="phone" required>
                </div>
              </div>

              <!-- Contact Person -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Contact Person</label>
                  <input type="text" class="form-control" id="contactPerson" placeholder="ex: Wasiu Chukwuma"
                    name="contactPerson" [(ngModel)]="contactPerson" required>
                </div>
              </div>
              <!-- Contact Person Email -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Contact Person Email</label>
                  <input type="text" class="form-control" id="ContactPersonEmail" placeholder="ex: Wasiu Chukwuma"
                    name="ContactPersonEmail" [(ngModel)]="ContactPersonEmail" required>
                </div>
              </div>
              <!-- Contractor Type -->
              <div class="col">
                <div class="form-group">
                  <label for="contract">Contractor Classification</label>
                  <select class="form-control" required [(ngModel)]="selectedContractType" name="selectedContractType">
                    <option value="0">--Select Classification--</option>
                    <option *ngFor="let eClass of ContractorType | keyvalue" [value]="eClass.key">{{eClass.value}}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">

              <!-- Address -->
              <div class="col">
                <div class="form-group">
                  <label for="description">Address</label>
                  <input type="text" class="form-control" id="address" placeholder="Business address" name="address"
                    [(ngModel)]="address" required>
                </div>
              </div>

              <!-- Description  -->
              <div class="col">
                <div class="form-group">
                  <label for="description">Description</label>
                  <input type="text" class="form-control" id="description"
                    placeholder="Short description of contractor's business " name="description"
                    [(ngModel)]="description" required>
                </div>
              </div>

            </div>

            <button type="submit" class="btn btn-primary mr-2">Submit</button>
            <button class="btn btn-light">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>